// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"styles-module--categoryList--1XjBK","label":"styles-module--label--RmKuD","select":"styles-module--select--f4bzf"};